import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { merge } from 'rxjs';

import { Filter, FilterComponentBase, FilterKeys, IFilterList } from '../filters/filters';
import { ApproachFilter, FuelFilter, RunwayLengthFilter, ServiceFilter, ServiceType } from '../filters/airport-filters';
import { FuelType } from '../../business/models/business-fuel.model';
import { SearchQuery } from '../models/search-query.model';
import { ApproachType } from '../../airport/models/approach-type.model';
import { GlobalSettingsService } from '../../shared/services/global-settings.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';


@Component({
  selector: 'app-airport-filter-list',
  templateUrl: './airport-filter-list.component.html',
  styleUrls: ['./airport-filter-list.component.scss']
})
export class AirportFilterListComponent implements IFilterList, AfterViewInit {
  @Input() compact: boolean;
  @Input() query: SearchQuery;
  @Output() filtersChange = new EventEmitter<void>();
  @Output() numSelectedChange = new EventEmitter<number>();
  @Output() publicUseChanged = new EventEmitter<boolean>();

  @ViewChildren(FilterComponentBase) filterComponents: QueryList<FilterComponentBase>;

  FilterKeys = FilterKeys;
  prevNumSelected = null;

  constructor(private _cdRef: ChangeDetectorRef,
              private _globalSettingsService: GlobalSettingsService,
              private _analyticsService: AnalyticsService) {}

  ngAfterViewInit() {
    merge(...this.filterComponents.map(f => f.change.asObservable()))
      .subscribe(() => {
        this.filtersChange.emit();
        this.updateNumSelected();
      });
    setTimeout(() => {
      this.updateNumSelected();
      this.filtersChange.emit();
    }, 300);
    this._analyticsService.pageView('airport_landingpage_airport', 'Airport Landing Page filters');
  }

  onPublicUseChanged() {
    this.publicUseChanged.emit((<Filter>this.query.getFilter(FilterKeys.PublicUse)).enabled);
  }

  updateNumSelected() {
    const numSelected = this.getNumSelected();
    if (numSelected !== this.prevNumSelected) {
      this.numSelectedChange.emit(numSelected);
      this.prevNumSelected = numSelected;
    }
  }

  getNumSelected(): number {
    if (!this.filterComponents) {
      return 0;
    }
    const selected = this.filterComponents.filter(c => c.filter.enabled).length;
    this._cdRef.detectChanges();
    return selected;
  }

  get fuel100LLFilter(): Filter {
    return (<FuelFilter[]>this.query.getFilter(FilterKeys.FuelFilter))
      .find(f => f.fuelType === FuelType._100LL);
  }

  get fuelJetAFilter(): Filter {
    return (<FuelFilter[]>this.query.getFilter(FilterKeys.FuelFilter))
      .find(f => f.fuelType === FuelType.JetA);
  }

  get fuelMOGASFilter(): Filter {
    return (<FuelFilter[]>this.query.getFilter(FilterKeys.FuelFilter))
      .find(f => f.fuelType === FuelType.MOGAS);
  }

  get fuelUL94Filter(): Filter {
    return (<FuelFilter[]>this.query.getFilter(FilterKeys.FuelFilter))
      .find(f => f.fuelType === FuelType.UL94);
  }

  get rwyLenFilter(): RunwayLengthFilter {
    return this.query.getFilter(FilterKeys.RunwayLength) as RunwayLengthFilter;
  }

  get ilsApproachFilter(): ApproachFilter {
    return (<ApproachFilter[]>this.query.getFilter(FilterKeys.Approach))
      .find(f => f.approach === ApproachType.ILS);
  }

  get rnavApproachFilter(): ApproachFilter {
    return (<ApproachFilter[]>this.query.getFilter(FilterKeys.Approach))
      .find(f => f.approach === ApproachType.RNAV);
  }

  get vorApproachFilter(): ApproachFilter {
    return (<ApproachFilter[]>this.query.getFilter(FilterKeys.Approach))
      .find(f => f.approach === ApproachType.VOR);
  }

  get airframeRepairFilter(): ServiceFilter {
    return (<ServiceFilter[]>this.query.getFilter(FilterKeys.Services))
      .find(f => f.service === ServiceType.AirframeRepair);
  }

  get engineRepairFilter(): ServiceFilter {
    return (<ServiceFilter[]>this.query.getFilter(FilterKeys.Services))
      .find(f => f.service === ServiceType.EngineRepair);
  }

  get avionicsRepairFilter(): ServiceFilter {
    return (<ServiceFilter[]>this.query.getFilter(FilterKeys.Services))
      .find(f => f.service === ServiceType.AvionicsRepair);
  }

  fuelChange(e: any, fuelType: string) {
    this._globalSettingsService.changeFuelType(fuelType);
    if (fuelType === '100LL' && e) {
      this.fuelJetAFilter.enabled = false;
      this.fuelMOGASFilter.enabled = false;
      this.fuelUL94Filter.enabled = false;
    }
    if (fuelType === 'JetA' && e) {
      this.fuel100LLFilter.enabled = false;
      this.fuelMOGASFilter.enabled = false;
      this.fuelUL94Filter.enabled = false;
    }
    if (fuelType === 'MOGAS' && e) {
      this.fuel100LLFilter.enabled = false;
      this.fuelJetAFilter.enabled = false;
      this.fuelUL94Filter.enabled = false;
    }
    if (fuelType === 'UL94' && e) {
      this.fuel100LLFilter.enabled = false;
      this.fuelMOGASFilter.enabled = false;
      this.fuelJetAFilter.enabled = false;
    }
    // this.filtersChange.emit();
    // this._cdRef.detectChanges();
    /* console.log('100LL: ', this.fuel100LLFilter.enabled);
    console.log('JetA: ', this.fuelJetAFilter.enabled);
    console.log('MOGAS: ', this.fuelMOGASFilter.enabled);
    console.log('UL94: ', this.fuelUL94Filter.enabled); */
  }
}
